import React from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import Lottie from 'lottie-react';
import success from 'assets/img/animated-icons/check-primary-light.json';
import warning from 'assets/img/animated-icons/warning-light.json';
import error from 'assets/img/animated-icons/error.json';

const ModalAlert = ({
    show,
    message,
    type,
    onHide,
    onConfirm,
    confirmButton
}) => {
    return (
        <Modal
            show={show}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            animation={false}
        >
            <Modal.Body>
                <Row className="align-items-center">
                    <Col lg={12} className="d-flex justify-content-center">
                        <Lottie loop={false} animationData={success} style={{height: '50%', width: '50%'}} className={type !== 'success' ? 'd-none' : ''} />
                        <Lottie loop={false} animationData={warning} style={{height: '45%', width: '45%'}} className={type !== 'warning' ? 'd-none' : ''} />
                        <Lottie loop={false} animationData={error} style={{height: '45%', width: '45%'}} className={type !== 'error' ? 'd-none' : ''} />
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center align-center">
                        <h3 className="text-center">{message}</h3>
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center">
                        {
                            confirmButton ? (
                                <>
                                    <Button className="m-1" variant="secondary" onClick={onHide}>Tidak</Button>
                                    <Button className="m-1" variant="success" onClick={onConfirm}>Ya</Button>
                                </>
                            ) : (
                                <Button className="m-1" variant="success" onClick={onHide}>OK</Button>
                            )
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

ModalAlert.propsTypes = {}

export default ModalAlert;